import { VODCSSModules } from 'shared/utils/wix-connect';

import styles from './player.styl';

@VODCSSModules(styles)
export default class Player extends React.Component {

  static propTypes = {
    appSettings: React.PropTypes.object,
    siteUrl: React.PropTypes.string,
    channelData: React.PropTypes.object,
    onFullScreenChanged: React.PropTypes.func,
  };

  render() {

    return (
      <div styleName="container">
        TODO: Play
        <br />
        Full-screen modal, Inline play or inline for mobile
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/views/desktop/compact/components/player/player.js